import React, { FC } from 'react';
import { OfflineOrderPageSkeleton } from '../offlineOrder/offlineOrderSkeleton';

export const OrderDesignEditorPageSkeleton: FC = () => <OfflineOrderPageSkeleton />;
